// The plug mark (design document: ring stroke one tenth of the face, pins one fifth,
// gap one pin, pins a little above centre). With `disc`, it sits on a charcoal disc.
// `small` is the mark drawn at 16 px, where the ring thickens to 2 px (12.5 of 100).
export const plugMark = ({ disc = false, small = false } = {}) =>
  '<svg class="plug" viewBox="0 0 100 100" aria-hidden="true">' +
  (disc ? '<circle class="disc" cx="50" cy="50" r="50" fill="#1B1E23"/>' : '') +
  (small
    ? '<circle class="ring" cx="50" cy="50" r="43.75" fill="none" stroke="#F5C95C" stroke-width="12.5"/>'
    : '<circle class="ring" cx="50" cy="50" r="45" fill="none" stroke="#F5C95C" stroke-width="10"/>') +
  '<circle class="prong" cx="30" cy="46" r="10" fill="#F5C95C"/>' +
  '<circle class="prong" cx="70" cy="46" r="10" fill="#F5C95C"/></svg>';

const icon = paths =>
  `<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="square" aria-hidden="true">${paths}</svg>`;

export const SETTINGS = icon('<circle cx="12" cy="12" r="3"/><circle cx="12" cy="12" r="7"/><path d="M12 2v3M12 19v3M2 12h3M19 12h3M4.9 4.9l2.1 2.1M17 17l2.1 2.1M4.9 19.1L7 17M17 7l2.1-2.1"/>');
export const BACK = icon('<path d="M20 12H5M11 6l-6 6 6 6"/>');
export const SHARE = icon('<path d="M8 10H5v11h14V10h-3M12 15V3M8 7l4-4 4 4"/>');
export const ADD_SQUARE = icon('<rect x="4" y="4" width="16" height="16"/><path d="M12 8v8M8 12h8"/>');
export const CLOSE = icon('<path d="M6 6l12 12M18 6L6 18"/>');
